import ThryvHubspot_EventListeners from "./EventListeners";

var ThryvHubspot = new Object();

ThryvHubspot.version = "1.0.0";

ThryvHubspot.init = function () {
  ThryvHubspot_EventListeners.listen();

  // console.log('ThryvHubspot.init:', this.version);
};

export default ThryvHubspot;
